import React from 'react';
import Theme from '../theme';
import BuildFemaleFullBody from '../assets/images/build-body-images/build-female-full-body.png';
import BuildFemaleBackArms from '../assets/images/build-body-images/build-female-back&arms.png';
import BuildFemaleLower from '../assets/images/build-body-images/build-female-lower.png';
import BuildFemaleUpper from '../assets/images/build-body-images/build-female-upper.png';

import BuildMaleFullBody from '../assets/images/build-body-images/build-male-full-body.png';
import BuildMaleBackArms from '../assets/images/build-body-images/build-male-back&arms.png';
import BuildMaleLower from '../assets/images/build-body-images/build-male-lower.png';
import BuildMaleUpper from '../assets/images/build-body-images/build-male-upper.png';

export const buildBodyImages = {
  'female - ': BuildFemaleFullBody,
  'female - Lower': BuildFemaleLower,
  'female - Upper': BuildFemaleUpper,
  'female - Back & Arms': BuildFemaleBackArms,
  'female - Lower Upper': BuildFemaleFullBody,
  'female - Back & Arms Lower': BuildFemaleFullBody,
  'female - Back & Arms Upper': BuildFemaleFullBody,
  'female - Back & Arms Lower Upper': BuildFemaleFullBody,

  'male - ': BuildMaleFullBody,
  'male - Lower': BuildMaleLower,
  'male - Upper': BuildMaleUpper,
  'male - Back & Arms': BuildMaleBackArms,
  'male - Lower Upper': BuildMaleFullBody,
  'male - Back & Arms Lower': BuildMaleFullBody,
  'male - Back & Arms Upper': BuildMaleFullBody,
  'male - Back & Arms Lower Upper': BuildMaleFullBody
};

import BurnFemaleFullBody from '../assets/images/burn-body-images/burn-female-full-body.png';
import BurnFemaleBackArms from '../assets/images/burn-body-images/burn-female-back&arms.png';
import BurnFemaleLower from '../assets/images/burn-body-images/burn-female-lower.png';
import BurnFemaleUpper from '../assets/images/burn-body-images/burn-female-upper.png';

import BurnMaleFullBody from '../assets/images/burn-body-images/burn-male-full-body.png';
import BurnMaleBackArms from '../assets/images/burn-body-images/burn-male-back&arms.png';
import BurnMaleLower from '../assets/images/burn-body-images/burn-male-lower.png';
import BurnMaleUpper from '../assets/images/burn-body-images/burn-male-upper.png';

export const burnBodyImages = {
  'female - ': BurnFemaleFullBody,
  'female - Lower': BurnFemaleLower,
  'female - Upper': BurnFemaleUpper,
  'female - Back & Arms': BurnFemaleBackArms,
  'female - Lower Upper': BurnFemaleFullBody,
  'female - Back & Arms Lower': BurnFemaleFullBody,
  'female - Back & Arms Upper': BurnFemaleFullBody,
  'female - Back & Arms Lower Upper': BurnFemaleFullBody,

  'male - ': BurnMaleFullBody,
  'male - Lower': BurnMaleLower,
  'male - Upper': BurnMaleUpper,
  'male - Back & Arms': BurnMaleBackArms,
  'male - Lower Upper': BurnMaleFullBody,
  'male - Back & Arms Lower': BurnMaleFullBody,
  'male - Back & Arms Upper': BurnMaleFullBody,
  'male - Back & Arms Lower Upper': BurnMaleFullBody
};

import MaleFullBodyIcon from '../assets/images/greyed-out/male-full-body.png';
import MaleLowerIcon from '../assets/images/greyed-out/male-lower.png';
import MaleBackAndArmsIcon from '../assets/images/greyed-out/male-back&arms.png';
import MaleUpperIcon from '../assets/images/greyed-out/male-upper.png';

import FemaleFullBodyIcon from '../assets/images/greyed-out/female-full-body.png';
import FemaleLowerIcon from '../assets/images/greyed-out/female-lower.png';
import FemaleUpperIcon from '../assets/images/greyed-out/female-upper.png';
import FemaleBackAndArmsIcon from '../assets/images/greyed-out/female-back&arms.png';

export const bodyImageGreyScale = {
  'female - ': FemaleFullBodyIcon,
  'female - Lower': FemaleLowerIcon,
  'female - Upper': FemaleUpperIcon,
  'female - Back & Arms': FemaleBackAndArmsIcon,
  'female - Lower Upper': FemaleFullBodyIcon,
  'female - Back & Arms Lower': FemaleFullBodyIcon,
  'female - Back & Arms Upper': FemaleFullBodyIcon,
  'female - Back & Arms Lower Upper': FemaleFullBodyIcon,

  'male - ': MaleFullBodyIcon,
  'male - Lower': MaleLowerIcon,
  'male - Upper': MaleUpperIcon,
  'male - Back & Arms': MaleBackAndArmsIcon,
  'male - Lower Upper': MaleFullBodyIcon,
  'male - Back & Arms Lower': MaleFullBodyIcon,
  'male - Back & Arms Upper': MaleFullBodyIcon,
  'male - Back & Arms Lower Upper': MaleFullBodyIcon
};

import BurnMaleFullBodySmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-male-full-body.png';
import BurnMaleLowerSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-male-lower.png';
import BurnMaleUpperSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-male-upper.png';
import BurnMaleBackAndArmsSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-male-back&arms.png';

import BuildMaleFullBodySmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-male-full-body.png';
import BuildMaleLowerSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-male-lower.png';
import BuildMaleUpperSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-male-upper.png';
import BuildMaleBackAndArmsSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-male-back&arms.png';

import BurnFemaleFullBodySmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-female-full-body.png';
import BurnFemaleLowerSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-female-lower.png';
import BurnFemaleUpperSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-female-upper.png';
import BurnFemaleBackAndArmsSmallDetailed from '../assets/images/burn-body-images/small-image-less-detail/burn-female-back&arms.png';

import BuildFemaleFullBodySmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-female-full-body.png';
import BuildFemaleLowerSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-female-lower.png';
import BuildFemaleUpperSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-female-upper.png';
import BuildFemaleBackAndArmsSmallDetailed from '../assets/images/build-body-images/small-image-less-detail/build-female-back&arms.png';

export const smallDetailedBurnBodyImages = {
  'male - ': BurnMaleFullBodySmallDetailed,
  'male - Lower': BurnMaleLowerSmallDetailed,
  'male - Upper': BurnMaleUpperSmallDetailed,
  'male - Back & Arms': BurnMaleBackAndArmsSmallDetailed,
  'male - Back & Arms Lower Upper': BurnMaleFullBodySmallDetailed,

  'female - ': BurnFemaleFullBodySmallDetailed,
  'female - Lower': BurnFemaleLowerSmallDetailed,
  'female - Upper': BurnFemaleUpperSmallDetailed,
  'female - Back & Arms': BurnFemaleBackAndArmsSmallDetailed,
  'female - Back & Arms Lower Upper': BurnFemaleFullBodySmallDetailed,
}

export const smallDetailedBuildBodyImages = {
  'male - ': BuildMaleFullBodySmallDetailed,
  'male - Lower': BuildMaleLowerSmallDetailed,
  'male - Upper': BuildMaleUpperSmallDetailed,
  'male - Back & Arms': BuildMaleBackAndArmsSmallDetailed,
  'male - Back & Arms Lower Upper': BuildMaleFullBodySmallDetailed,

  'female - ': BuildFemaleFullBodySmallDetailed,
  'female - Lower': BuildFemaleLowerSmallDetailed,
  'female - Upper': BuildFemaleUpperSmallDetailed,
  'female - Back & Arms': BuildFemaleBackAndArmsSmallDetailed,
  'female - Back & Arms Lower Upper': BuildFemaleFullBodySmallDetailed,
}

import FemaleFullBodyDash from '../assets/images/body-images-dashboard/body_female-full.png';
import FemaleBackArmsDash from '../assets/images/body-images-dashboard/body_female-back&arms.png';
import FemaleBackArmsLowerDash from '../assets/images/body-images-dashboard/body_female-lower-back&arms.png';
import FemaleLowerDash from '../assets/images/body-images-dashboard/body_female-lower.png';
import FemaleUpperDash from '../assets/images/body-images-dashboard/body_female-upper.png';
import FemaleUpperLowerDash from '../assets/images/body-images-dashboard/body_female-upper-lower.png';
import FemaleUpperBackArmsDash from '../assets/images/body-images-dashboard/body_female-upper-back&arms.png';

import MaleFullBodyDash from '../assets/images/body-images-dashboard/body_male-full.png';
import MaleBackArmsDash from '../assets/images/body-images-dashboard/body_male-back&arms.png';
import MaleBackArmsLowerDash from '../assets/images/body-images-dashboard/body_male-lower-back&arms.png';
import MaleLowerDash from '../assets/images/body-images-dashboard/body_male-lower.png';
import MaleUpperDash from '../assets/images/body-images-dashboard/body_male-upper.png';
import MaleUpperLowerDash from '../assets/images/body-images-dashboard/body_male-upper-lower.png';
import MaleBackArmsUpperDash from '../assets/images/body-images-dashboard/body_male-uppr-back&arms.png';

export const bodyImagesDash = {
  'female - ': FemaleFullBodyDash,
  'female - Lower': FemaleLowerDash,
  'female - Upper': FemaleUpperDash,
  'female - Back & Arms': FemaleBackArmsDash,
  'female - Lower Upper': FemaleUpperLowerDash,
  'female - Back & Arms Lower': FemaleBackArmsLowerDash,
  'female - Back & Arms Upper': FemaleUpperBackArmsDash,
  'female - Back & Arms Lower Upper': FemaleFullBodyDash,

  'male - ': MaleFullBodyDash,
  'male - Lower': MaleLowerDash,
  'male - Upper': MaleUpperDash,
  'male - Back & Arms': MaleBackArmsDash,
  'male - Lower Upper': MaleUpperLowerDash,
  'male - Back & Arms Lower': MaleBackArmsLowerDash,
  'male - Back & Arms Upper': MaleBackArmsUpperDash,
  'male - Back & Arms Lower Upper': MaleFullBodyDash,
};

import FemaleFullBodyOrange from '../assets/images/body-images-dashboard/body-female-full-body.svg';
import FemaleLowerBodyOrange from '../assets/images/body-images-dashboard/body-female-lower.svg';
import FemaleUpperBodyOrange from '../assets/images/body-images-dashboard/body-female-upper.svg';
import FemaleBackAndArmsOrange from '../assets/images/body-images-dashboard/body-female-back&arms.svg';
import MaleFullBodyOrange from '../assets/images/body-images-dashboard/body-male-full-body.svg';
import MaleLowerBodyOrange from '../assets/images/body-images-dashboard/body-male-lower.svg';
import MaleUpperBodyOrange from '../assets/images/body-images-dashboard/body-male-upper.svg';
import MaleBackAndArmsOrange from '../assets/images/body-images-dashboard/body-male-back&arms.svg';

export const bodyImage = (fill1, fill2, fill3, width, height, svgKey) => {
  const preserveAspectRatio = 'xMidYMid meet';
  const viewBox = '0 0 512 512';
  const orangeBodyImages  = {
    'female - ' : <FemaleFullBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height} viewBox={viewBox} primaryColor={Theme.PRIMARY} />,
    'female - Lower': <FemaleLowerBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height} preserveAspectRatio={preserveAspectRatio} viewBox={viewBox}
                                             primaryColor={Theme.PRIMARY} />,
    'female - Upper': <FemaleUpperBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
    width={width} height={height} preserveAspectRatio={preserveAspectRatio} viewBox={viewBox}
                                             primaryColor={Theme.PRIMARY} />,
    'female - Back & Arms': <FemaleBackAndArmsOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height} preserveAspectRatio={preserveAspectRatio} viewBox={viewBox}
                                                     primaryColor={Theme.PRIMARY} />,
    'female - Back & Arms Lower Upper': <FemaleFullBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height} preserveAspectRatio={preserveAspectRatio} viewBox={viewBox}
                                                              primaryColor={Theme.PRIMARY} />,
    'male - ' : <MaleFullBodyOrange primaryColor={Theme.PRIMARY} />,
    'male - Lower': <MaleLowerBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height}
    preserveAspectRatio={preserveAspectRatio} viewBox={viewBox} primaryColor={Theme.PRIMARY} />,
    'male - Upper': <MaleUpperBodyOrange fill={fill1} fillSecondary={fill2} color ={fill3} width={width} height={height}
    preserveAspectRatio={preserveAspectRatio} viewBox={viewBox} primaryColor={Theme.PRIMARY} />,
    'male - Back & Arms': <MaleBackAndArmsOrange fill={fill1} fillSecondary={fill2} color={fill3}
     width={width} height={height}
    preserveAspectRatio={preserveAspectRatio} viewBox={viewBox} primaryColor={Theme.PRIMARY} />,
    'male - Back & Arms Lower Upper': <MaleFullBodyOrange fill={fill1} fillSecondary={fill2} color={fill3}
    width={width} height={height} preserveAspectRatio={preserveAspectRatio} viewBox={viewBox}
                                                          primaryColor={Theme.PRIMARY} />,
  };
  return orangeBodyImages[svgKey];
};

import MaleNoneDash from '../assets/images/body-images-dashboard/body_male-none.png';
import FemaleNoneDash from '../assets/images/body-images-dashboard/body_female-none.png';

export const noWorkoutGreyScale = {
  'female - ': FemaleNoneDash,

  'male - ': MaleNoneDash,
};
